import WorkBlock from "domain/WorkBlock";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useWorkBlockShowModal from "hooks/state/useWorkBlockShowModal";
import React from "react";
import ReadOnlyWorkBlockModalView from "./ReadOnlyWorkBlockModalView";

export default function ReadOnlyWorkBlockModalContainer() {
  const { block: blockData, isOpen, close } = useWorkBlockShowModal();
  const applicationContext = useApplicationContext();

  if (!blockData) return null;

  const {
    customerSettings: { workBlockLayout },
  } = applicationContext;
  const { block } = blockData;
  const effectiveProductionRate = WorkBlock.effectiveProductionRate(block);
  const workBlockQuantity = WorkBlock.quantity(block);

  return (
    <ReadOnlyWorkBlockModalView
      blockData={blockData}
      effectiveProductionRate={effectiveProductionRate}
      isOpen={isOpen}
      onClose={close}
      productionRateLabel="Standard production rate"
      workBlockLayout={workBlockLayout}
      workBlockQuantity={workBlockQuantity}
    />
  );
}
